import React from 'react';
import { BoxIcon } from 'lucide-react';
interface KpiCardProps {
  title: string;
  value: string;
  icon: BoxIcon;
  color: string;
  iconColor: string;
}
export function KpiCard({
  title,
  value,
  icon: Icon,
  color,
  iconColor
}: KpiCardProps) {
  return <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-2245">
      <div className="flex items-start justify-between" data-id="element-2246">
        <div data-id="element-2247">
          <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2248">{title}</h3>
          <p className="text-2xl font-bold" data-id="element-2249">{value}</p>
        </div>
        <div className={`p-3 rounded-full ${color}`} data-id="element-2250">
          <Icon size={24} className={iconColor} data-id="element-2251" />
        </div>
      </div>
    </div>;
}